var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgbody(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5920,
    height: 7580,
    viewBox: "0 0 1920 7580",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_124_83)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5920,
    height: 7580,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 23,
    width: 5920,
    height: 8412,
    fill: "#F9FBFE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_124_83)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 199,
    r: 575,
    fill: "#A9D2FE",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_124_83)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 3212,
    r: 575,
    fill: "#A9D2FE",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_124_83)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 5515,
    r: 575,
    fill: "#A9D2FE",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_124_83)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1593,
    cy: 1827,
    r: 575,
    fill: "#A9D2FE",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_124_83)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1593,
    cy: 4431,
    r: 575,
    fill: "#A9D2FE",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_124_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2168 6908C2168 7225.56 1910.56 7483 1593 7483C1275.44 7483 1018 7225.56 1018 6908C1018 6590.44 1275.44 6333 1593 6333C1910.56 6333 2168 6590.44 2168 6908Z",
    fill: "#A9D2FE",
    fillOpacity: 0.4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_124_83",
    x: -806,
    y: -847,
    width: 5092,
    height: 2092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 235.5,
    result: "effect1_foregroundBlur_124_83"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_124_83",
    x: -786,
    y: 2166,
    width: 5092,
    height: 2092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 235.5,
    result: "effect1_foregroundBlur_124_83"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_124_83",
    x: -786,
    y: 4469,
    width: 5092,
    height: 2092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 235.5,
    result: "effect1_foregroundBlur_124_83"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_124_83",
    x: 547,
    y: 781,
    width: 5092,
    height: 2092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 235.5,
    result: "effect1_foregroundBlur_124_83"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_124_83",
    x: 547,
    y: 3385,
    width: 5092,
    height: 2092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 235.5,
    result: "effect1_foregroundBlur_124_83"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_124_83",
    x: 547,
    y: 5862,
    width: 5092,
    height: 2092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 235.5,
    result: "effect1_foregroundBlur_124_83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_124_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5920,
    height: 7580,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgbody);
export default __webpack_public_path__ + "static/media/bgbody.43b491734357ff499608e0680a1632eb.svg";
export { ForwardRef as ReactComponent };